var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticStyle:{"height":"100%"},attrs:{"id":"inspire"}},[_c('div',{staticClass:"mainBackground",attrs:{"id":"app"}},[(_vm.isLogged)?_c('sidebar',{attrs:{"avatar":_vm.avatar}}):_vm._e(),_c('v-main',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }